module.exports = __webpack_public_path__ + "img/share.e9bd10f6.svg";